var _metadata, _defs, _sodipodiNamedview, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    sodipodiDocname: "tick.svg",
    inkscapeVersion: "1.0.1 (c497b03c, 2020-09-10)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata880"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs878"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 1404,
    "inkscapeWindow-height": 818,
    id: "namedview876",
    showgrid: "false",
    inkscapeZoom: 0.69751766,
    inkscapeCx: 123.97865,
    inkscapeCy: 209.48713,
    "inkscapeWindow-x": 0,
    "inkscapeWindow-y": 215,
    "inkscapeWindow-maximized": 0,
    "inkscapeCurrent-layer": "Capa_1",
    "inkscapeDocument-rotation": 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g837",
    style: {
      stroke: "none",
      strokeOpacity: 1,
      fill: "#4b793c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g835",
    style: {
      stroke: "none",
      strokeOpacity: 1,
      fill: "#4b793c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.36,69.995c-7.532-7.545-19.753-7.558-27.285-0.032L238.582,300.845l-83.522-90.713    c-7.217-7.834-19.419-8.342-27.266-1.126c-7.841,7.217-8.343,19.425-1.126,27.266l97.126,105.481    c3.557,3.866,8.535,6.111,13.784,6.22c0.141,0.006,0.277,0.006,0.412,0.006c5.101,0,10.008-2.026,13.623-5.628L497.322,97.286    C504.873,89.761,504.886,77.54,497.36,69.995z",
    id: "path833",
    style: {
      stroke: "none",
      strokeOpacity: 1,
      fill: "#4b793c",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g843",
    style: {
      stroke: "none",
      strokeOpacity: 1,
      fill: "#4b793c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g841",
    style: {
      stroke: "none",
      strokeOpacity: 1,
      fill: "#4b793c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.703,236.703c-10.658,0-19.296,8.638-19.296,19.297c0,119.883-97.524,217.407-217.407,217.407    c-119.876,0-217.407-97.524-217.407-217.407c0-119.876,97.531-217.407,217.407-217.407c10.658,0,19.297-8.638,19.297-19.296    C275.297,8.638,266.658,0,256,0C114.84,0,0,114.84,0,256c0,141.154,114.84,256,256,256c141.154,0,256-114.846,256-256    C512,245.342,503.362,236.703,492.703,236.703z",
    id: "path839",
    style: {
      stroke: "none",
      strokeOpacity: 1,
      fill: "#4b793c",
      fillOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g845"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g847"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g849"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g851"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g853"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g855"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g857"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g859"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g861"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g863"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g865"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g867"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g869"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g871"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "g873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.9c354e312c460ca6508750b6c45a83de.svg";
export { ForwardRef as ReactComponent };